import * as React from "react";
import {WithTranslation, withTranslation} from "react-i18next";
import {compose} from "redux";
import {connect} from "react-redux";
import {
  downloadTraceHistoryToXLSX as downloadTraceHistoryToXLSXActionCreator,
  IDateRangeParams
} from "Redux/Actions/VehicleActions";
import SidebarHeader, {ISidebarHeader} from "components/Layout/SidebarHeader/SidebarHeader.Component";
import * as HistoryModule from "Modules/HistoryModule";
import moment from "moment";

interface IHistoryRideHeader extends Pick<ISidebarHeader, 'onBack'> {
  rideDetails: HistoryModule.Types.CarRideDetailsResponse
}

interface IDispatchedProps {
  downloadTraceHistoryToXLSX: (dateRange: IDateRangeParams) => void
}

const HistoryRideHeader = ({
  onBack,
  t,
  downloadTraceHistoryToXLSX,
  rideDetails
}: IHistoryRideHeader & WithTranslation & IDispatchedProps): JSX.Element => {
  const options = React.useMemo(() => [
    {
      content: t('forms:GET_TRACE_AS_EXCEL'),
      id: "GET_TRACE_AS_EXCEL",
      onClick: () => {
        downloadTraceHistoryToXLSX({
          startDate: moment(rideDetails.startDate),
          endDate: moment(rideDetails.endDate)
        })
      }
    }
  ], [downloadTraceHistoryToXLSX])

  return (
    <SidebarHeader
      onBack={onBack}
      label={t('carHistory')}
      //@ts-ignore
      dropdown={{ id: 'GET_TRACE_AS', label: t('forms:GET_TRACE_AS'), options }}
    />
  )
}


function mapDispatchToProps(dispatch: any): IDispatchedProps {
  return {
    downloadTraceHistoryToXLSX: (dateRange) => dispatch(downloadTraceHistoryToXLSXActionCreator(dateRange))
  }
}

export default compose(
  connect(null, mapDispatchToProps),
  withTranslation(['carDetails', 'forms']),
)(HistoryRideHeader)



// WEBPACK FOOTER //
// ./src/components/Map/CarDetails/Components/HistoryRideHeader.Component.tsx